import React, { useEffect, useState } from 'react'
import { Get_Api } from '../API_URL';
import Aos from 'aos';

function TermsandCondition() {
    const [termsandcondition, settermsandcondition] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const GetTermsandcondition = async () => {
        try {
            setIsLoading(true);
            const response = await Get_Api("api/admin/GetTermsandcondition");
            settermsandcondition(response?.data?.Termsandcondition);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        GetTermsandcondition();
    }, []);

    useEffect(() => {
        Aos.init({
            duration: 1000, // animation speed
            once: true,     // run only once
            easing: "ease-out",
        });
    }, []);
    return (
        <>
            <section className="relative overflow-hidden lg:mt-[72px] mt-[66px]">
                <img
                    src="/assets/our/bg2.png"
                    className="h-[200px] sm:h-[250px] md:h-[300px] w-full object-cover"
                    alt=""
                />
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center px-4">
                    <h2 className="font-neue text-[26px] sm:text-[32px] md:text-[40px] text-white">
                        Terms & Conditions
                    </h2>
                </div>
            </section>
            <section className="max-w-[900px] mx-auto px-4 py-10">
                {isLoading ? (
                    <p className="text-center text-gray-600">Loading...</p>
                ) : (
                    <div
                        className="blog-content prose prose-lg max-w-none font-neue text-[#333]"
                        dangerouslySetInnerHTML={{ __html: termsandcondition }}
                    />
                )}
            </section>
        </>
    );
}

export default TermsandCondition;
